import { Flex } from "antd";
import Button from "../../../Helpers/Button/Button";
import PlaybackDate from "./PlaybackDate";
import { usePlayback } from "../../../../context/VideoPlayback";
import VehicleSelect from "../../Video/VehicleSelect";

export default function PlaybackHeader({
  vehicles,
  feeds,
  setSelectedFeeds,
  selectedValues,
  isLoading,
  setLayoutType,
}) {
  const { layoutType } = usePlayback();
  return (
    <>
      <div className="bg-white p-16">
        <Flex vertical={false} justify="space-between" gap={80}>
          <Flex vertical={false} style={{ flex: 1 }} gap={20}>
            <VehicleSelect
              maxCount={layoutType}
              vehicles={vehicles}
              feeds={feeds}
              setSelectedFeeds={setSelectedFeeds}
              selectedValues={selectedValues}
              isLoading={isLoading}
            />
            <PlaybackDate />
          </Flex>
          <Flex vertical={false} gap={"small"}>
            <Button
              onClick={() => setLayoutType(1)}
              type={"default"}
              text={"1 cam"}
            />
            <Button
              onClick={() => setLayoutType(2)}
              type={"default"}
              text={"4 cams"}
            />
            <Button
              onClick={() => setLayoutType(3)}
              type={"default"}
              text={"6 cams"}
            />
            <Button
              onClick={() => setLayoutType(5)}
              type={"default"}
              text={"8 cams"}
            />
            <Button
              onClick={() => setLayoutType(4)}
              type={"default"}
              text={"9 cams"}
            />
          </Flex>
        </Flex>
      </div>
    </>
  );
}
